export default __webpack_public_path__ + "static/media/join.ae93036b.png";